// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".statusbar {\n  width: 100%;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-box-ordinal-group: 1;\n      -ms-flex-order: 0;\n          order: 0;\n}\n@media (max-width: 640px) {\n  html.device-iphone-x .statusbar {\n    display: none;\n  }\n  html.device-ios:not(.device-iphone-x) .statusbar {\n    height: 20px;\n  }\n  html.device-android .statusbar {\n    height: 0px;\n  }\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
